export default __webpack_public_path__ + "static/media/cardingreso.65373bc4.png";